import isNaN from 'lodash/isNaN';
import isNumber from 'lodash/isNumber';

import { getThemeColor } from '../../../utils/theme-utils';

export const dataArrayAsDataSet = (data, label) => ({ data, label });

export const formatSingleLineChart = dataset => ({
  ...dataset,
  borderColor: '#03374E',
  fill: true,
  pointRadius: 0,
})

export const formatSinglePointChart = dataset => ({
  ...dataset,
  borderWidth: 0,
  pointHoverBorderWidth: 2,
  fill: false,
})

export const formatAssayPointDatasets = (datasetOk, datasetAlert) => [
  {
    ...datasetOk,
    borderWidth: 0,
    pointBackgroundColor: '#2EA873',
    pointHoverBorderWidth: 2,
    fill: false,
  },
  {
    ...datasetAlert,
    borderWidth: 0,
    pointBackgroundColor: '#a83e2e',
    pointHoverBorderWidth: 2,
    fill: false,
  }
]

export const formatSequencedBarChartDatasets = (dataset, index, arr) => {
  const isLast = arr?.length === index + 1;

  return {
    ...dataset,
    pointRadius: 0,
    barColor: isLast ? getThemeColor('chart.window') : getThemeColor('chart.baseline'),
    // backgroundColor: isLast ? getThemeColor('faded.window') : getThemeColor('faded.baseline'),
    // fill: isLast ? 'origin' : '+1',
  }
}

export const formatSequencedLineChartDatasets = (dataset, index, arr) => {
  const isLast = arr?.length === index + 1;
  const isFirst = index === 0;

  return {
    ...dataset,
    lineColor: isFirst ? '#03374E' : isLast ? '#D2080F' : '#E5B50F',
    borderColor: isFirst ? '#03374E' : isLast ? '#D2080F' : '#E5B50F',
    bgColor: isFirst ? '#03374E' : isLast ? '#D2080F' : '#E5B50F',
  }
}

export const getParsedChartPoint = (pointVal, label) => {
  const parsedVal = isNumber(pointVal) ? pointVal : parseFloat(pointVal);
  return ({
    y: isNumber(parsedVal) && !isNaN(parsedVal) ? parsedVal : null,
    x: new Date(label),
  })
}

export const getThreeDatasetLineChartDatasets = (dataArr1, dataArr2, dataArr3) => [
  {
    id: 'p99-lat',
    label: 'p99 latency',
    data: dataArr1?.filter(({ y }) => isNumber(y)),
  },
  {
    id: 'p95-lat',
    label: 'p95 latency',
    data: dataArr2?.filter(({ y }) => isNumber(y)),
  },
  {
    id: 'p50-lat',
    label: 'p50 latency',
    data: dataArr3?.filter(({ y }) => isNumber(y)),
  },
]

export const getBarChartComparisonDatasets = (baselineData, windowData) => [
  {
    id: 'Window',
    data: windowData,
    barColor: getThemeColor('chart.window'),
  },
  {
    id: 'Baseline',
    data: baselineData,
    barColor: getThemeColor('chart.baseline'),
  },
]
